import * as St from '../OutageBanner.styles';
import { type ActiveBannerMessage } from '../useOutageBanner';

export const WarningBanner = ({
  title,
  message,
  onDismiss,
}: {
  title: string;
  message: ActiveBannerMessage;
  onDismiss: () => void;
}) => (
  <St.BannerBar data-type="warning">
    <St.Content>
      <St.TitleRow>
        <St.RedInfoIcon />
        <St.TitleText>{title}</St.TitleText>
      </St.TitleRow>
      <St.DescriptionRow>
        <St.Description dangerouslySetInnerHTML={{ __html: message.html }} />
      </St.DescriptionRow>
    </St.Content>

    <St.CloseButton onClick={onDismiss} aria-label="Dismiss banner">
      <St.CloseIcon />
    </St.CloseButton>
  </St.BannerBar>
);

export default WarningBanner;
